import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/system';
import { FocusTheme } from '@/components/Focus/configs/theme';

const CalendarButton: React.FC<ButtonProps> = (props) => {
  return <ButtonStyled variant="contained" {...props} />;
};

export default CalendarButton;

const ButtonStyled = styled(Button)`
  border: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.border};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.69rem;
  color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.text};
  background-color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.background};
  box-shadow: none;

  &:hover {
    background-color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.hover};
    box-shadow: none;
  }
`;
